import "./utils/sentry";
import "./index.css";
import App from "./App";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./Hooks/AuthHook";
import { GomonAPIProvider } from "./Hooks/GomonApiHook";
import { GenesisAPIProvider } from "./Hooks/GenesisApiHook";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { ClerkProvider } from "@clerk/clerk-react";

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

const root = createRoot(document.getElementById("root"));

root.render(
  <LocalizationProvider dateAdapter={AdapterMoment}>
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
      <AuthProvider>
        <GomonAPIProvider>
          <GenesisAPIProvider>
            <App />
          </GenesisAPIProvider>
        </GomonAPIProvider>
      </AuthProvider>
    </ClerkProvider>
  </LocalizationProvider>,
);
